export const USER_USAGE_FEATURES = [
  'home',
  'documents',
  'collections',
  'payment_links',
  'reports',
  'customers',
  'items',
  'orders',
  'automations',
  'notifications',
  'assistant',
  'conversations',
  'reminders',
  'settings',
  'other',
] as const;

export type UserUsageFeature = (typeof USER_USAGE_FEATURES)[number];

const PATH_FEATURES: Array<[string, UserUsageFeature]> = [
  ['/payment-links', 'payment_links'],
  ['/create-payment', 'payment_links'],
  ['/create-document', 'documents'],
  ['/documents', 'documents'],
  ['/collections', 'collections'],
  ['/reports', 'reports'],
  ['/customers', 'customers'],
  ['/items', 'items'],
  ['/orders', 'orders'],
  ['/automations', 'automations'],
  ['/notifications', 'notifications'],
  ['/conversations', 'conversations'],
  ['/reminders', 'reminders'],
  ['/settings', 'settings'],
  ['/modules', 'settings'],
  ['/home', 'home'],
  ['/overview', 'home'],
];

export function featureForPath(pathname: string): UserUsageFeature {
  return PATH_FEATURES.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`))?.[1] ?? 'other';
}

export function canViewUserUsage(role?: string | null): boolean {
  return role === 'owner' || role === 'admin';
}
